export default "__VITE_ASSET__e1cd2aba__"